<template>
  <div>
    <el-row>
      <el-col>
        <el-button size="medium" @click="addLine">新增</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="线路名称" prop="LINE_NAME"></el-table-column>
          <el-table-column label="操作" min-width="30px">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="lineDetail(scope.row)">匹配的项目点</el-button>
              <el-button type="text" size="small" @click="matchCar(scope.row)">匹配车辆</el-button>
              <el-button type="text" size="small" @click="modify(scope.row)">修改</el-button>
              <el-button type="text" size="small" @click="del(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog title="新增线路" center :visible.sync="addFormVisible" width="600px">
      <el-form :model="addForm" ref="addForm" size="small">
        <el-form-item label="线路名称：" :label-width="formLabelWidth">
          <el-input v-model="lineInput" placeholder="请输入线路名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addFormVisible = false">取 消</el-button>
        <el-button size="small" @click="$_submitAdd()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改线路" center :visible.sync="modifyVisible" width="600px" :close-on-click-modal="false">
      <el-form size="small">
        <el-form-item label="线路名称：" :label-width="formLabelWidth">
          <el-input v-model="modifyInput.LINE_NAME" placeholder="请输入线路名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="modifyVisible = false">取 消</el-button>
        <el-button size="small" @click="submitModify()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getLineSetList, submitAdd } from 'api/systemSetting';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      // loading:false,
      tableData: [],
      addFormVisible: false,
      lineInput: '',
      addForm: {},
      formLabelWidth: '100px',
      modifyVisible: false,
      modifyInput: {},
    };
  },
  created() {
    this.$_getLineSetList();
  },
  methods: {
    // 获取线路配置的信息
    $_getLineSetList() {
      getLineSetList().then((res) => {
        this.tableData = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 点击匹配的项目点
    lineDetail(row) {
      this.$router.push({ name: 'lineSetDetail', params: { id: row.ID } });
    },
    matchCar(row) {
      this.$router.push({ path: `matchCar/${row.ID}`, params: { id: row.ID } });
    },
    // 点击新增
    addLine() {
      this.addFormVisible = true;
    },
    $_submitAdd() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const data = {
            LINE_NAME: this.lineInput,
          };
          if (!this.lineInput) {
            this.$message.show({ text: '请输入线路名称', type: 'warning' });
            return false;
          }
          submitAdd(data).then((res) => {
            this.$message.show({ text: '新增成功', type: 'success' });
            this.addFormVisible = false;
            this.$_getLineSetList();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // 修改路线
    modify(row) {
      this.modifyInput = row;
      this.modifyVisible = true;
    },
    submitModify() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const data = {
            SERVICE_ID: '10043',
            OTYPE: 9,
            GYS_ID: sessionStorage.getItem('tcId'),
            LINE_ID: this.modifyInput.ID,
            LINE_NAME: this.modifyInput.LINE_NAME,
          };
          if (!this.modifyInput.LINE_NAME) {
            this.$message.show({ text: '请输入线路名称', type: 'warning' });
            return false;
          }
          http.post(data).then((res) => {
            this.$message.show({ text: '修改成功', type: 'success' });
            this.modifyVisible = false;
            this.$_getLineSetList();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // 删除路线
    del(row) {
      this.$confirm('本操作将删除该分类下匹配的全部项目点, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const data = {
          SERVICE_ID: '10043',
          OTYPE: 8,
          LINE_ID: row.ID,
        };
        http.post(data).then((res) => {
          this.$message.show({ text: '删除成功', type: 'success' });
          this.$_getLineSetList();
        }).catch((err) => {
          this.$message.show({ text: err, type: 'error' });
        });
      }).catch(() => {
        this.$message.show({ text: '取消删除', type: 'info' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sortingAndDistribution/lineSet.vue